import { ImageAsset } from '../images/image-asset-model';
import { Breadcrumb } from './breadcrumb.model';

export class Album
{
    Id: number;
    Name: string;
    Description: string;
    IsPublished: boolean;
    ParentId: number;
    ChildAlbums: Album[];
    IsFolder = false;
    CategoryIds: number[] = [];
    Thumbnail: ImageAsset;
    PhotosCount: number;
    VideosCount: number;
    ImageAssets: ImageAsset[];
    Breadcrumbs: any[] = [];

    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            // Custom mappings
            if (json['Thumbnail'] != null) this.Thumbnail = new ImageAsset(json['Thumbnail']);
            this.ImageAssets = json['ImageAssets'] == null ? [] : json['ImageAssets'].map(image => new ImageAsset(image));
            this.ChildAlbums = json['ChildAlbums'] == null ? [] : json['ChildAlbums'].map(album => new Album(album));
            this.Breadcrumbs = json['Breadcrumbs'] == null ? [] : json['Breadcrumbs'].map(breadcrumb => new Breadcrumb(breadcrumb));

            // Eliminate stuff we don't want
            delete this['Order'];
        }
    }
}
